// Stealed from: https://stackoverflow.com/questions/10744645/detect-touchpad-vs-mouse-in-javascript/31191250#31191250

let _isTrackpad;
let _eventCount = 0;
let _eventCountStart;

const detectTrackpad = evt => {
  //console.log('detectTrackpad');
  if(_isTrackpad !== undefined) {
    document.removeEventListener('wheel', detectTrackpad);
    return;
  }
  
  if (_eventCount === 0) {
    _eventCountStart = performance.now();
  }

  _eventCount++;

  if (performance.now() - _eventCountStart > 66) {
    if (_eventCount >= 5) {
      _isTrackpad = true;
    } else {
      _isTrackpad = false;
    }
    //console.log('_isTrackpad: ', _isTrackpad);
  }
};

setTrackpad();

export function isTrackpad() {
    return _isTrackpad;
}

export function setTrackpad(b = undefined) {
  _isTrackpad = b;
  if(b === undefined) {
    _eventCount = 0;
    document.addEventListener('wheel', detectTrackpad, {passive: true});
  }
}
